var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"spinnerWrapper",attrs:{"fill-height":"","grid-list-md":"","text-xs-center":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('grid-loader',{staticClass:"text--primary",attrs:{"color":_vm.spinnerColor}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }